import ManagePlayersTab from "@/components/ManagePlayersTab";
import PendingInvitesCard from "@/components/admin/PendingInvitesCard";
import BulkMagicLinkModal from "@/components/admin/BulkMagicLinkModal";
import { useState } from "react";
import { Send } from "lucide-react";

export default function PlayersTab({ league, leagueId, tournament, data, sessionData, isLocked, onChanged }) {
    const [showBulkMagic, setShowBulkMagic] = useState(false);
    const participants = data?.participants || [];
    const nonAdminCount = participants.filter((p) => p.id !== league?.admin_participant_id).length;

    return (
        <div className="space-y-5">
            {nonAdminCount > 0 && (
                <div className="brutal-card p-3 flex items-center gap-3 flex-wrap" data-testid="bulk-magic-link-launcher">
                    <div className="flex-1 min-w-0">
                        <p className="text-[11px] font-bold uppercase tracking-wide text-cyber">Send join links</p>
                        <p className="text-[10px] text-zinc-400 leading-snug">
                            Email a 30-minute magic link to crewmates so they can jump in without hunting for a code.
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={() => setShowBulkMagic(true)}
                        disabled={isLocked}
                        data-testid="bulk-magic-link-open-btn"
                        className="brutal-btn-primary text-xs px-3 py-1.5 flex items-center gap-1.5 disabled:opacity-40"
                    >
                        <Send className="w-3.5 h-3.5" /> Send links
                    </button>
                </div>
            )}
            <PendingInvitesCard
                leagueId={leagueId}
                inviteCode={league?.invite_code}
                participants={participants}
                isLocked={isLocked}
                onChanged={onChanged}
            />
            <ManagePlayersTab
                leagueId={leagueId}
                participants={participants}
                currentParticipantId={sessionData?.participant_id}
                adminParticipantId={league?.admin_participant_id}
                isLocked={isLocked}
                teamCount={tournament?.teams?.length || 0}
                onChanged={onChanged}
            />
            {showBulkMagic && (
                <BulkMagicLinkModal
                    leagueId={leagueId}
                    participants={participants}
                    adminParticipantId={league?.admin_participant_id}
                    currentParticipantId={sessionData?.participant_id}
                    onClose={() => setShowBulkMagic(false)}
                />
            )}
        </div>
    );
}
